import React from "react";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { QualificationQuiz } from "@/components/forms/QualificationQuiz";
import { MapView } from "@/components/MapView";
import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/data/site";
import { track } from "@/lib/analytics";

export default function Contatti() {
  return (
    <>
      <Seo title="Contatti — Richiedi informazioni su SENIORCAR"
        description="Contatta SENIORCAR per informazioni, preventivi e per scoprire se è la soluzione giusta per te o per un tuo familiare."
        keywords="contatti seniorcar, richiedi informazioni" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Contatti" }]} /></div>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6 grid lg:grid-cols-2 gap-10">
        <div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Parliamo di mobilità</h1>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">Compila il breve questionario per ricevere informazioni personalizzate, oppure contattaci direttamente.</p>
          <div className="mt-8 space-y-4">
            <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-4 rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-md transition-shadow" onClick={() => track("phone_click", { source: "contatti" })} data-testid="contatti-phone">
              <span className="w-12 h-12 rounded-xl flex items-center justify-center text-white" style={{ backgroundColor: "var(--sc-emerald)" }}><Phone size={22} /></span>
              <div><p className="font-bold text-slate-900">Chiamaci</p><p className="text-slate-600">{PHONE}</p></div>
            </a>
            <a href="mailto:info@seniorcar.it" className="flex items-center gap-4 rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-md transition-shadow" data-testid="contatti-email">
              <span className="w-12 h-12 rounded-xl flex items-center justify-center text-white" style={{ backgroundColor: "var(--sc-amber)" }}><Mail size={22} /></span>
              <div><p className="font-bold text-slate-900">Email</p><p className="text-slate-600">info@seniorcar.it</p></div>
            </a>
            <div className="rounded-2xl bg-white border border-slate-200 p-5" data-testid="contatti-sede">
              <p className="font-bold text-slate-900 flex items-center gap-2"><MapPin size={20} className="text-[color:var(--sc-emerald)]" /> La nostra sede</p>
              <p className="text-slate-600 mt-1">Via Isaac Newton 9, 20016 Pero (Milano)</p>
              <div className="mt-4"><MapView pin="accent" grayscale height={220} zoom={13}
                points={[{ id: "sede", lat: 45.5108, lng: 9.0876, title: "SENIORCAR — Sede", subtitle: "Via Isaac Newton 9, Pero (MI)" }]} /></div>
            </div>
          </div>
        </div>
        <div className="lg:pt-2"><QualificationQuiz /></div>
      </section>

      <div className="h-16" />
    </>
  );
}
